const Error404 = (props: any) => {
    return (<div>
        <h4>Page Not found 404</h4>
    </div>)
}

export default Error404;